var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81.398,
    height: 55.583,
    viewBox: "0 0 81.398 55.583",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7439",
    "data-name": "Path 7439",
    d: "M40.666,55.529c-10.091,0-20.186-.129-30.273.052A10.065,10.065,0,0,1,0,45.149C.137,33.59.033,22.028.04,10.468.042,4.065,4.089,0,10.468,0Q40.8,0,71.131,0c5.018,0,9.013,3.01,9.971,7.511a13.1,13.1,0,0,1,.273,2.689q.027,17.624,0,35.246c-.014,5.226-3.355,9.253-8.182,9.969a14.678,14.678,0,0,1-2.14.106q-15.194.01-30.388,0ZM77.523,13.042c-.563.3-.924.474-1.274.671q-17.1,9.531-34.193,19.07a2.583,2.583,0,0,1-2.761-.038q-16.59-9.283-33.2-18.53c-.667-.373-1.356-.707-2.113-1.1-.034.321-.063.468-.063.615q0,16.092.009,32.184a5.179,5.179,0,0,0,.2,1.442c.816,2.788,2.985,4.307,6.135,4.307q30.266,0,60.53,0c4.442,0,6.727-2.291,6.727-6.756q0-15.245,0-30.492V13.04ZM4.066,8.62c.375.226.691.425,1.017.608q17.35,9.67,34.695,19.35a1.636,1.636,0,0,0,1.839.016Q55.994,20.541,70.4,12.542c2.327-1.3,4.646-2.607,7.126-4a17.517,17.517,0,0,0-1.311-2.422,6.123,6.123,0,0,0-5.287-2.23q-30.215.037-60.432.016c-.413,0-.829,0-1.24.034A5.7,5.7,0,0,0,4.066,8.62Z",
    transform: "translate(0.004)",
    fill: "#3873ae"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.6d9477738a3eb311a201b4f1d0da909b.svg";
export { ForwardRef as ReactComponent };